"use client";

import { formatDateString, convertTimeString } from "@/apiUtils/commonUtils";
import { dateFormats } from "@/apiUtils/constants";
import { SuccessSectionContent } from "@/common/lib/types";
import Button from "@/components/ui/button/Button";
import Modal from "@/components/ui/modal_new/Modal";
import { FC, useState } from "react";

type CancelConfirmationModalProps = {
  content?: SuccessSectionContent;
  isOpen: boolean;
  slotDate: string;
  startTime?: string;
  toggle: () => void;
  onConfirm: (reason: string) => void;
};

const CancelConfirmationModal: FC<CancelConfirmationModalProps> = ({
  content,
  isOpen,
  slotDate,
  startTime,
  toggle,
  onConfirm,
}) => {
  const [reason, setReason] = useState<string>("");

  const getSlotDetails = () => {
    return `${formatDateString(slotDate, dateFormats.MMMM_DD_YYYY)} - ${convertTimeString(startTime)}`;
  };

  const handleConfirm = () => {
    onConfirm(reason);
    setReason("");
  };

  const handleClose = () => {
    setReason("");
    toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      slots={{
        container: { style: { width: "23.938rem" } },
        root: { className: "z-[25]" },
        // container: { className: "w-full sm:w-[23.938rem]" },
      }}
    >
      <div className="w-full pr-8" style={{ paddingRight: "2rem" }}>
        <div className="font-semibold">{content?.cancelModalTitle}</div>
        <div className="mt-4 text-sm font-normal">
          {content?.cancelModalMessage?.replace("{{slot}}", getSlotDetails())}
        </div>

        {/* Reason textarea */}
        <div className="mt-4">
          <label className="mb-2 block text-[14px]">
            {content?.cancelReasonLabel || "Reason for cancellation (optional)"}
          </label>
          <textarea
            className="w-full rounded border border-gray-300 p-2 text-[14px]"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            maxLength={500}
            placeholder={
              content?.cancelReasonPlaceholder || "Please provide a reason for cancellation..."
            }
          />
          <p className="mt-1 text-right text-[12px] text-gray-500">
            {reason.length}/500
          </p>
        </div>

        <div className="mb-4 mt-4 flex items-center justify-start gap-4">
          <Button
            className="flex w-full items-center justify-center border-2 border-black bg-transparent text-[0.875rem] font-bold text-black"
            style={{ height: "3rem", width: "fit-content", textAlign: "center" }}
            onClick={handleClose}
          >
            {content?.cancelModalCancelButton}
          </Button>
          <Button
            className="flex w-full items-center justify-center whitespace-nowrap text-[0.875rem] font-bold"
            style={{ height: "3rem", width: "fit-content", textAlign: "center" }}
            onClick={handleConfirm}
          >
            {content?.cancelModalConfirmButton}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CancelConfirmationModal;
